import { Component } from '@theme/component';

class MiamiBrandDirectory extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.initialize();
  }

  updatedCallback() {
    super.updatedCallback();
    this.initialize();
  }

  initialize() {
    if (!(this.refs.search instanceof HTMLInputElement)) return;
    this.querySelector('[data-search-controls]').hidden = false;
    this.filterBrands();
  }

  normalize(value) {
    return value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^\p{L}\p{N}]+/gu, ' ').trim();
  }

  filterBrands() {
    const { search, count, empty, clear } = this.refs;
    if (!(search instanceof HTMLInputElement)) return;
    const words = this.normalize(search.value).split(/\s+/).filter(Boolean);
    const visibleGroups = new Set();
    let matches = 0;
    for (const item of this.querySelectorAll('[data-brand-name]')) {
      const name = this.normalize(item.dataset.brandName || '');
      const visible = words.every(word => name.includes(word));
      item.hidden = !visible;
      if (visible) {
        matches += 1;
        visibleGroups.add(item.dataset.brandGroup);
      }
    }
    for (const label of this.querySelectorAll('[data-brand-letter]')) {
      label.hidden = !visibleGroups.has(label.id);
    }
    for (const jump of this.querySelectorAll('[data-brand-jump]')) {
      jump.hidden = !visibleGroups.has(jump.dataset.brandJump);
    }
    if (count) count.textContent = matches === 1 ? this.dataset.singleResult : (this.dataset.countTemplate || '__COUNT__').replace('__COUNT__', String(matches));
    if (empty) empty.hidden = matches !== 0;
    if (clear) clear.hidden = search.value.length === 0;
  }

  clearSearch() {
    const search = this.refs.search;
    if (!(search instanceof HTMLInputElement)) return;
    search.value = '';
    this.filterBrands();
    search.focus();
  }
}

if (!customElements.get('miami-brand-directory')) {
  customElements.define('miami-brand-directory', MiamiBrandDirectory);
}
